import React from 'react';
import { RouteObject } from 'react-router-dom';
import { appRoutes } from '../../path';
import SidebarLayout from '../../Layout/SidebarLayout';
import RedirectRoute from '../RedirectRoute';
import IncidentNav from './IncidentNav/IncidentNav';
import ManageIncident from './ManageIncident';
import Calendar from './Calendar';

const incidentRoutes: RouteObject[] = [
  // Legacy routes
  {
    path: '/events/!/*',
    element: (
      <RedirectRoute from="/events/!/*" to={appRoutes.incidents.manage} />
    ),
  },
  {
    element: (
      <SidebarLayout>
        <IncidentNav />
      </SidebarLayout>
    ),
    children: [
      {
        path: appRoutes.incidents.routePrefix,
        element: (
          <RedirectRoute
            from={appRoutes.incidents.routePrefix}
            to={appRoutes.incidents.manage}
          />
        ),
      },
      {
        path: appRoutes.incidents.manage,
        element: <ManageIncident />,
      },
      {
        path: appRoutes.incidents.calendar,
        element: <Calendar />,
      },
    ],
  },
];

export default incidentRoutes;
